import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import queryString from 'query-string';
import Gallery from 'react-photo-gallery';
import { tabResultState } from '../../../modules/tabResult';
import { tabAIState } from '../../../modules/tabAI';
import { media } from '../../common/Layout';

interface styleType {
  PatentTitleBoxMargin?: number;
}

const PatentComponent = styled.div`
  margin-top: 24px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;
`;

const PatentImageContent = styled.div`
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
`;

const PatentTextContent = styled.div`
  /* Mobile Device */
  padding: 12px;

  ${media.desktop`
    padding: 20px;
  `};
`;

const PatentTitleBox = styled.div`
  font-family: 'NotoKrM';
  display: flex;
  align-items: center;

  margin-top: ${(props: styleType) => props.PatentTitleBoxMargin || 0}px;

  /* Mobile Device */
  font-size: 15px;
  margin-bottom: 6px;
  height: 22px;

  ${media.desktop`
    height: 30px;
    font-size: 18px;
    margin-bottom: 10px;
  `};
`;
const PatentTitleHighlight = styled.div`
  display: flex;
  font-family: 'NotoKrM';
`;
const PatentTitleText = styled.div`
  display: flex;
  font-family: 'NotoKrR';
`;

const PatentDescBox = styled.div`
  font-family: 'NotoKrL';
  color: #222222;
  &:last-child {
    margin-bottom: 0px;
  }

  /* Mobile Device */
  font-size: 13px;
  margin-bottom: 6px;

  ${media.desktop`
    font-size: 14px;
    margin-bottom: 10px;
  `};
`;

const PatentSourceBox = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  margin-bottom: 20px;
`;

const PatentSubBox = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

const PatentSubTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  margin-right: 6px;
`;

const PatentKindsText = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #222222;
`;
const PatentKindsTitle = styled.div``;

const Data = {
  title: '정책',
  desc:
    '결정 사항을 안내하고 합리적인 결과를 수행할 수 있게 하는 원칙이나 규율을 가리킨다. 사전적 의미로는 정치나 정무를 시행하는 방침이다.',
  source: 'Wikipedia',
  kinds: ['인적 자원 정책', '개인 정보 정책', '공공정책'],
  link: ['(영어) Policy institutes - Curlie', 'www.naver.com'],
};

const photos = [
  {
    src: 'https://source.unsplash.com/2ShvY8Lf6l0/800x599',
    width: 4,
    height: 3,
    alt: '1',
  },
  {
    src: 'https://source.unsplash.com/Dm-qxdynoEc/800x799',
    width: 1,
    height: 1,
    alt: '2',
  },
];

type PatentProps = {
  patentData: tabAIState['patentData'];
};

interface PatentState {}

function isString(val: string | string[]): val is string {
  return typeof val === 'string';
}

class Patent extends React.PureComponent<PatentProps, PatentState> {
  makeList = (): ReactNode[] | null => {
    const query = queryString.parse(window.location.search);
    let keyword: string | string[] = '';

    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
    }

    const { patentData } = this.props;
    const result: ReactNode[] | null = [];
    result.push(
      <PatentTitleBox>
        <PatentTitleHighlight>{keyword}</PatentTitleHighlight>
        <PatentTitleText>이(가) 포함된 특허</PatentTitleText>
      </PatentTitleBox>
    );
    result.push(<PatentDescBox>{patentData.patent}</PatentDescBox>);
    result.push(
      <PatentTitleBox PatentTitleBoxMargin={30}>
        <PatentTitleHighlight>{keyword}</PatentTitleHighlight>
        <PatentTitleText>관련 특허</PatentTitleText>
      </PatentTitleBox>
    );
    patentData.related_patent.forEach((element) => {
      result.push(<PatentDescBox>{element}</PatentDescBox>);
    });
    return result;
  };

  render() {
    const { patentData } = this.props;
    return (
      <PatentComponent>
        {/* <PatentImageContent>
          <Gallery
            photos={photos}
            targetRowHeight={130}
            limitNodeSearch={10}
            margin={0}
          />
        </PatentImageContent> */}
        <PatentTextContent>
          {patentData.patent.length > 0 ? <>{this.makeList()}</> : null}

          {/* <PatentSubBox>
            <PatentSubTitle>종류</PatentSubTitle>
            <PatentKindsText>{Data.kinds}</PatentKindsText>
          </PatentSubBox>
          <PatentSubBox>
            <PatentSubTitle>외부링크</PatentSubTitle>
            <PatentKindsText>{Data.link[0]}</PatentKindsText>
          </PatentSubBox> */}
        </PatentTextContent>
      </PatentComponent>
    );
  }
}

export default Patent;
